import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SetpointsList from './SetpointsList';
import { getSetpoints, getUserProfileWidget, getCurrentTimezone, getUserOrgModelCategoryType } from '../../selectors/index';
import {
  saveSetpointsThunk,
  setSetpointsChangeThunk,
  getSetpointsThunk,
  setCurrentPage,
  setPageFilter,
  resetSetpointsThunk
} from '../../actions/setpoints';

const mapStateToProps = state => {
  return {
    setpoints: getSetpoints(state),
    userProfileWidgets: getUserProfileWidget(state),
    currentTimezone: getCurrentTimezone(state),
    userModelCategories: getUserOrgModelCategoryType(state)

  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSetpoints: (modelCategoryId, offset, limit, filter) => getSetpointsThunk(modelCategoryId, offset, limit, filter, 'SETPOINTS_TAB'),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
      saveSetpoints: (setpoints, widgetCode) => saveSetpointsThunk(setpoints, widgetCode),
      setSetpointsChange: setpoints => setSetpointsChangeThunk(setpoints),
      resetSetpoints: setpoints => resetSetpointsThunk(setpoints)

    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SetpointsList);
